var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarningIc = function SvgWarningIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .5a7 7 0 1 0 .001 14.001A7 7 0 0 0 7 .5Zm-.5 3.625c0-.069.056-.125.125-.125h.75c.069 0 .125.056.125.125v4.25a.125.125 0 0 1-.125.125h-.75a.125.125 0 0 1-.125-.125v-4.25ZM7 11a.75.75 0 0 1 0-1.5.75.75 0 0 1 0 1.5Z",
    fill: "#FAAD14"
  })));
};

export default SvgWarningIc;